import {
    isWithdrawnByDefault,
    Project,
    ProjectType
} from "in_queue/types/projectType";
import {
    MisoPercentageReduction,
    ProjectSizeAdjustmentType
} from "in_queue/types/scenarioType";

export interface ProjectSelection {
    readonly projectSizeAssumptions: Record<string, MisoPercentageReduction>;
    readonly includedSpeculativeProjectIds: ReadonlyArray<string>;
}

const FULL_REDUCTION: MisoPercentageReduction = {
    type: ProjectSizeAdjustmentType.PERCENTAGE_REDUCTION,
    eris: 100,
    nris: 100
};

export const defaultProjectSelection = (
    allProjects: ReadonlyArray<Project>
): ProjectSelection => {
    const projectSizeAssumptions: Record<string, MisoPercentageReduction> = {};
    const includedSpeculativeProjectIds: string[] = [];

    allProjects.forEach((project) => {
        if (isWithdrawnByDefault(project)) {
            projectSizeAssumptions[project.projectId] = FULL_REDUCTION;
            return;
        }
        if (project.type === ProjectType.SPECULATIVE_PROJECT) {
            includedSpeculativeProjectIds.push(project.projectId);
        }
    });

    return { projectSizeAssumptions, includedSpeculativeProjectIds };
};
